import { useEffect, useRef } from "react";
import { useLocation } from "react-router";
import { trackAnalyticsEvent } from "@/utils/analytics";

const AnalyticsTracker = () => {
  const location = useLocation();
  const previousPathRef = useRef("");

  useEffect(() => {
    const path = `${location.pathname}${location.search}`;
    if (!path || previousPathRef.current === path) return;
    previousPathRef.current = path;

    trackAnalyticsEvent({
      eventType: "page_view",
      pagePath: path,
    });
  }, [location.pathname, location.search]);

  return null;
};

export default AnalyticsTracker;
